export enum ConsumerSessionStatus {
  Unknown = 'unknown',
  NotStarted = 'notStarted',
  Pending = 'pending',
  PreSubmission = 'preSubmission',
  PostSubmission = 'postSubmission',
}
